import React from 'react';
import { Row, Col } from 'antd';
import styled from 'styled-components/macro';

import Heading from 'components/Heading/Heading';

import EnquiryInfoBg from './images/enq-info-bg.png';
import EnquiryBigEmailPNG from './images/enq-big-email.png';
import EnquiryPinIcon from './images/enq-pin-icon.png';
import EnquiryEmailIcon from './images/enq-email-icon.png';

const EnquiryInfoHeader = ({ className, title }) => (
  <Col span={20} lg={16} className={className}>
    <Heading size="sub" color="white">
      {title}
    </Heading>
  </Col>
);

const StyledEnquiryInfoHeader = styled(EnquiryInfoHeader)`
  img {
    height: 100%;
    margin-right: 16px;
  }
  display: flex;
  flex-direction: row;
`;

const EnquiryBigEmail = ({ className }) => (
  <Col span={20} lg={16} className={className}>
    <img alt="enquiry big email" src={EnquiryBigEmailPNG} />
  </Col>
);

const StyledEnquiryBigEmail = styled(EnquiryBigEmail)`
  text-align: center;
  margin: 8px 0px;
  img {
    width: 50%;
  }

  @media (min-width: 992px) {
    img {
      width: 75%;
    }
  }
`;

const IconText = ({ icon, children, className }) => (
  <Row type="flex" justify="center" align="top" className={className}>
    <Col span={2} lg={4}>
      <img alt={children} src={icon} />
    </Col>
    <Col span={22} lg={20}>
      {children}
    </Col>
  </Row>
);

const StyledIconText = styled(IconText)`
  margin-bottom: 8px;
`;

const EnquiryInfoContact = () => (
  <Col span={20} lg={14}>
    <StyledIconText icon={EnquiryPinIcon}>Lot 17-07, Faber Towers, 207, Jalan Desa Bahagia, Taman Desa, 58100 Kuala Lumpur, Malaysia</StyledIconText>
    <StyledIconText icon={EnquiryEmailIcon}><a href="mailto:enquiry@hostastay.com" style={{color:"white"}}>enquiry@hostastay.com</a></StyledIconText>
  </Col>
);

const StyledEnquiryInfoRow = styled(Row)`
  background-image: url(${EnquiryInfoBg});
  width: 100%;
  background-size: cover;
  color: white;
  padding: 48px 0px;

  @media (min-width: 992px) {
    background-image: url(${EnquiryInfoBg});
    width: 32%;
    background-size: cover;
    color: white;
    padding: 48px 0px;
  }
`;

const getEnquiryInfoHeaderTitle = comingFrom => {
  switch (comingFrom) {
    case '/reno-calculator':
      return 'Do you want to know more about our design service?';
    default:
      return 'We\'d love to hear from you.'
  }
}

const EnquiryInfo = ({ prevPath }) => {
  return (
    <StyledEnquiryInfoRow type="flex" justify="center" align="top">
      <StyledEnquiryInfoHeader title={getEnquiryInfoHeaderTitle(prevPath)}/>
      <StyledEnquiryBigEmail />
      <EnquiryInfoContact />
    </StyledEnquiryInfoRow>
  );
};

export default EnquiryInfo;
